import { RoleTitles } from "views/settings-users/slices/users/constants";
import { VerificationTemplateOverriddenActivity } from "../types";

interface VerificationTemplateOverrideProps {
  activityItem: VerificationTemplateOverriddenActivity;
}

export const VerificationTemplateOverride = ({
  activityItem
}: VerificationTemplateOverrideProps) => {
  return (
    <div className="space-y-2">
      <div>
        <p className="text-base font-bold text-content-1000">
          Screening template was changed
        </p>
      </div>
      <div className="text-sm font-normal text-content-400">
        {activityItem.author?.name ? (
          <p>
            by {activityItem.author.name} (
            {RoleTitles[activityItem.author.author_role] || "--"})
          </p>
        ) : null}
        <p>
          Default template: {activityItem.details.original_template_name} •
          Changed to: {activityItem.details.overridden_template_name}
        </p>
      </div>
    </div>
  );
};
